import { render, staticRenderFns } from "./UserSalesWithEducationalCategoriesSettingsTable.vue?vue&type=template&id=3f289770&"
import script from "./UserSalesWithEducationalCategoriesSettingsTable.vue?vue&type=script&lang=js&"
export * from "./UserSalesWithEducationalCategoriesSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports